module.exports = {
  DEFAULT_LOCALE: "nl-BE",

  API_DATE_FORMAT: "YYYY-MM-DDTHH:mm:ss.SSSZZ",
  READABLE_DATE_FORMAT: "DD-MM-YYYY",

  // 50mb
  // MAX_UPLOAD_FILE_SIZE: 52428800,
  // 100mb
  // MAX_UPLOAD_FILE_SIZE: 104857600,
  // 250mb
  MAX_UPLOAD_FILE_SIZE: 262144000,


  WEBSOCKET_URL: `${ window.location.protocol === "https:" ? "wss" : "ws" }://${window.location.host}/services/1.0/realtime`,
  //WEBSOCKET_URL: "ws://localhost:8080/services/1.0/realtime",
  // WEBSOCKET_URL: "ws://10.4.2.16:8080/services/1.0/realtime",
  // WEBSOCKET_URL: "wss://hedgehog.cartamundi-digital.com/services/1.0/realtime",


  APP_ERROR_USER_NOT_LINKED_TO_GAMEBOARD: "E48579",
  USER_EMAIL_INVALID: "E73541",
  USER_NOT_AUTHENTICATED: "E45557",
  USER_NOT_FOUND: "E91489",
  USER_DUPLICATE_EMAIL: "E12319",
  PASSWORD_INCORRECT: "E73550",
  PASSWORD_FORMAT_INVALID: "E84597",
  GAMEBOARD_NOT_FOUND: "E66821",
  GAMEBOARD_MAX_USERS_REACHED: "E75931",

  WEBSOCKET_SERVICES: {
    START_SESSION: "start_session",
    PAUSE_SESSION: "pause_session",
    FINISH_SESSION: "finish_session",
    JOIN_SESSION: "join_session",
    SELECT_SESSION_GROUP: "select_session_group",
    UNSELECT_SESSION_GROUP: "unselect_session_group",
    SET_SESSION_GROUP_CHARACTER: "set_session_group_character",
    MOVE_CHARACTER: "move_character",
    PICKUP_MATERIAL: "pickup_material",
    DROP_MATERIAL: "drop_material"
  },

  WEBSOCKET_MESSAGES : {
    CHARACTER_SELECTED: "character_selected",
    CHARACTER_MOVED: "character_moved",
    SESSION_MATERIAL_PICKED_UP: "session_material_picked_up",
    SESSION_MATERIAL_DROPPED: "session_material_dropped",
    TURN_STARTED : "message_turn_started",
    TURN_ENDED : "message_turn_ended"
  },

  CHARACTER_ROTATIONS: {
    NORTH: 1,
    EAST: 2,
    SOUTH: 4,
    WEST: 8
  },
};



// WEBPACK FOOTER //
// ./app/js/config/constants.js